import Reg from "../pages/auth/reg";


export default function RegPage(){
	return (
		<Reg/>
	);
}